export const trainingWarningTreshold = 0.9
